import { z } from 'zod';

export const createQuestionSchema = z.object({
  module_id: z.uuid('Invalid module ID'),
  category_id: z.uuid('Invalid category ID'),
  scale_id: z.uuid('Invalid scale ID'),
  question: z.string().min(1, 'Question is required'),
  hint: z.string().optional(),
});

export type CreateQuestionPayload = z.infer<typeof createQuestionSchema>;
